import { UserAuthWrapper as userAuthWrapper } from 'redux-auth-wrapper'
import { routerActions } from 'react-router-redux'

export const userIsAuthenticated = userAuthWrapper({
  authSelector: state => state.user.auth,
  failureRedirectPath: '/login',
  redirectAction: routerActions.replace,
  wrapperDisplayName: 'userIsAuthenticated',
  predicate: auth => (auth.access_token && localStorage.getItem('access_token')),
})

export const userIsNotAuthenticated = userAuthWrapper({
  authSelector: state => state.user.auth,
  failureRedirectPath: (state, ownProps) => ownProps.location.query.redirect || '/',
  allowRedirectBack: false,
  redirectAction: routerActions.replace,
  wrapperDisplayName: 'userIsNotAuthenticated',
  predicate: auth => !(auth.access_token && localStorage.getItem('access_token')),
})

export const userIsAdmin = userAuthWrapper({
  authSelector: state => state.user.auth,
  redirectAction: routerActions.replace,
  failureRedirectPath: '/',
  wrapperDisplayName: 'userIsAdmin',
  predicate: auth => auth.isAdmin,
  allowRedirectBack: false,
})

export const visibleOnlyAdmin = userAuthWrapper({
  authSelector: state => state.user.auth,
  wrapperDisplayName: 'visibleOnlyAdmin',
  predicate: auth => auth.isAdmin,
  FailureComponent: null,
})



// WEBPACK FOOTER //
// ./src/utils/wrappers.jsx